import { getStores } from '../..';
import Cookies from 'js-cookie';

export const addMyLocation = (
  self,
  title,
  description,
  color,
  category,
  myLocations,
) => {

  if (
    self.errors.alreadyExists ||
    self.errors.description ||
    self.errors.title ||   
    self.errors.color ||   
    self.errors.category
  ) {
    return false;
  } 

  const { config } = getStores(self, 'config');
  const { layers } = getStores(self, 'layers');

  const locations = Cookies.get('custom-pois');

  const poi = customPoi(category, title, description, color, myLocations);

  if (locations) {
    const existingLocations = JSON.parse(locations);
    const found = existingLocations.find((obj) => {
      return obj.id === poi.id;
    });
    if (found) {
      self.errors.alreadyExists = true;
      return false;
    }

      self.errors = {
        alreadyExists: false,
        description: false,
        title: false,
        color: false,
        category: false,
      };
      existingLocations.push(poi);
      Cookies.set('custom-pois', JSON.stringify(existingLocations));
      self.deactivate();
      layers.closeModal();
    
  } else {

    self.errors = {
      alreadyExists: false,
      description: false,
      title: false,
      color: false,
      category: false,
    };
    const customLocations = [poi];
    var json_str = JSON.stringify(customLocations);
    Cookies.set('custom-pois', json_str);
    myLocations.fetch();
    self.deactivate();
    layers.closeModal();
    return true;
  }

  if (config.gysService.useMock) return;
  if (self.list.filter((x) => x.id === poi.id)?.length > 0) return;

  self.list.push(poi);
  return true;
};

const customPoi = (category, title, description, color, myLocations) => {
  const id = 'custom_poi_' + title;
  const icons = {
    food: 'eatdrink',
    shopping: 'shopping',
    sight: 'sight',
    parking: 'parking',
  };

  return {
    id,
    categories: [{ _id: category, name: icons[category], color: color }],
    location: {
      coordinates: [myLocations.newPoi[1], myLocations.newPoi[0]],
    },
    provider: 'custom_poi',
    images: [],
    copyright: {
      title: 'copyright',
    },
    en: { title: title, description: description },
    de: { title: title, description: description },
    nl: { title: title, description: description },
    fr: { title: title, description: description },
  };
};
